import Typography from '@components/typography'
import styled from '@emotion/styled'
import theme from '@utils/theme'

const SubscriptionContainer = styled.div`
  margin: 20px auto;
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 888px;
  @media (min-width: 768px) {
    border: 1px solid ${theme.colors.borderBlue};
    padding: 40px;
    border-radius: 10px;
  }
`

const SubscriptionDateText = styled.p`
  font-size: 14px;
  color: #555;
  align-self: flex-start;
`

const SubscriptionCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  padding: 4px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.05);
  margin-top: 10px;
`

const SubscriptionIconPlaceholder = styled.div`
  width: 50px;
  height: 50px;
  background: #d3eaff;
  border-radius: 50%;
`

const SubscriptionDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  gap: 8px;
  padding-left: 10px;
`

const SubscriptionTitleWrapper = styled.div`
  border-bottom: 1px solid #e0e0e0;
  width: 100%;
`

const SubscriptionSubtitle = styled.p`
  font-size: 12px;
  color: #777;
  margin: 0;
`

const SubscriptionPrice = styled.span`
  font-size: 14px;
  background: #d3eaff;
  padding: 5px 10px;
  border-radius: 6px;
`

const SubscriptionSectionTitle = styled(Typography)`
  margin: 20px 0 10px;
  color: #555;
  align-self: flex-start;
`

const SubscriptionPaymentCard = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 350px;
  padding: 15px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.05);
`

const SubscriptionPaymentIconPlaceholder = styled.div`
  width: 40px;
  height: 40px;
  background: #e0f0d9;
  border-radius: 50%;
`

const SubscriptionPaymentDetails = styled.div`
  padding-left: 10px;
`

const SubscriptionPaymentTitle = styled(Typography)`
  font-size: 14px;
`

const SubscriptionPaymentSubtitle = styled(Typography)`
  font-size: 12px;
  color: #777;
`

const SubscriptionSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  background: white;
  border-radius: 10px;
`

const SubscriptionRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
`

const SubscriptionLabel = styled(Typography)`
  font-size: 14px;
  color: #777;
`

const SubscriptionAmount = styled(Typography)`
  font-size: 14px;
`

const SubscriptionTotalLabel = styled(Typography)`
  font-size: 16px;
`

const SubscriptionTotalAmount = styled(Typography)`
  font-size: 16px;
  color: ${(props: any) => props.theme.colors.primary};
`

const SubscriptionButton = styled.button`
  width: 100%;
  max-width: 350px;
  padding: 12px;
  background: #007bff;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  margin-top: 20px;
  cursor: pointer;

  &:hover {
    background: #0056b3;
  }
`
export {
  SubscriptionContainer,
  SubscriptionDateText,
  SubscriptionCard,
  SubscriptionIconPlaceholder,
  SubscriptionDetails,
  SubscriptionTitleWrapper,
  SubscriptionSubtitle,
  SubscriptionPrice,
  SubscriptionSectionTitle,
  SubscriptionPaymentCard,
  SubscriptionPaymentIconPlaceholder,
  SubscriptionPaymentDetails,
  SubscriptionPaymentTitle,
  SubscriptionPaymentSubtitle,
  SubscriptionSummary,
  SubscriptionRow,
  SubscriptionLabel,
  SubscriptionAmount,
  SubscriptionTotalLabel,
  SubscriptionTotalAmount,
  SubscriptionButton,
}
